module.exports = __webpack_public_path__ + "img/azure-black.5f0d4c16.svg";